// ============================================================
// StarAxe Vault — bundle-qty-lock.js
// Bloqueia quantidade para produtos bundle
// Identificação via product handle ou title (contém 'bundle')
// ============================================================

(function () {

  function isBundle(item) {
    // Verifica pelo handle (URL do produto)
    if (item.handle && item.handle.toLowerCase().includes('bundle')) return true;
    // Verifica pelo título
    if (item.title && item.title.toLowerCase().includes('bundle')) return true;
    // Verifica pelo product_type
    if (item.product_type && item.product_type.toLowerCase().includes('bundle')) return true;
    return false;
  }

  async function getCartItems() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      return cart.items || [];
    } catch (e) {
      return [];
    }
  }

  async function lockBundleQuantities() {
    const items = await getCartItems();

    items.forEach((item, index) => {
      if (!isBundle(item)) return;

      const lineIndex = index + 1;

      // Página do carrinho — linha por ID
      const row = document.getElementById('CartItem-' + lineIndex);
      if (row) {
        row.querySelectorAll('.quantity__button').forEach(btn => {
          btn.style.display = 'none';
        });
        const input = row.querySelector('.quantity__input');
        if (input) {
          input.setAttribute('readonly', true);
          input.style.pointerEvents = 'none';
          input.style.opacity = '0.6';
        }
      }

      // Apanha por data-index (drawer e página)
      document.querySelectorAll(`[data-index="${lineIndex}"]`).forEach(el => {
        const wrapper = el.closest('quantity-input, .quantity, .cart-item__quantity-wrapper');
        if (wrapper) {
          wrapper.querySelectorAll('.quantity__button').forEach(btn => {
            btn.style.display = 'none';
          });
          const input = wrapper.querySelector('.quantity__input');
          if (input) {
            input.setAttribute('readonly', true);
            input.style.pointerEvents = 'none';
            input.style.opacity = '0.6';
          }
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', lockBundleQuantities);
  document.addEventListener('cart:updated', lockBundleQuantities);
  document.addEventListener('cart-drawer:open', lockBundleQuantities);

  const observer = new MutationObserver(() => lockBundleQuantities());
  observer.observe(document.body, { childList: true, subtree: true });
})();